import React from 'react';
import { fmtInt, fmtNumber, fmtCurrency, fmtPercent } from '../../utils/formatters';

/* <Num value={1234.5}   />          → 1.234,50
   <Num value={1234.5} fmt="€" />    → 1.234,50 €
   <Num value={18}     fmt="%" />    → 18,00 %
   <Num value={1000}   fmt="int" />  → 1.000                                    */
export default function Num({ value, fmt = 'dec' }) {
  switch (fmt) {
    case '€':   return <>{fmtCurrency(value)}</>;
    case '%':   return <>{fmtPercent(value)}</>;
    case 'int': return <>{fmtInt(value)}</>;
    default:    return <>{fmtNumber(value)}</>;
  }
}
